export default __webpack_public_path__ + "static/media/mana-screenshot.9b8248b9.png";